import React from 'react';
import { Search } from 'lucide-react';

export default function SearchBar({ value, onChange, placeholder = "Найти растение или товар…" }) {
  return (
    <label className="flex items-center gap-2 rounded-2xl bg-cream-card px-4 py-3 ring-1 ring-border-warm focus-within:bg-white focus-within:ring-green-sage">
      <Search className="h-5 w-5 text-green-muted" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-transparent text-sm outline-none placeholder:text-green-muted"
      />
    </label>
  );
}
